import { render } from "./ProductFilter.vue?vue&type=template&id=6d3110e7"
import script from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductFilter.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/modules/product-categorization/components/filter/ProductFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d3110e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d3110e7', __exports__)) {
    api.reload('6d3110e7', __exports__)
  }
  
  module.hot.accept("./ProductFilter.vue?vue&type=template&id=6d3110e7", () => {
    api.rerender('6d3110e7', render)
  })

}


export default __exports__